<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content is-wide">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add Slab Order Items</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div class="modal-card-body">

          <slab-item-selector 
            ref="item-selector"
            :project-id="projectId"
            @select="$emit('select', $event)"
            @deselect="$emit('deselect', $event)"/>

        </div>

        <footer class="modal-card-foot">
          <button 
            class="button is-primary" 
            @click.stop="close()">
            Done
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import SlabItemSelector from '@/components/inventory/SlabItemSelector'

export default {
  props: {
    value: {
      type: Boolean
    },
    projectId: {
      type: [String, Number]
    }
  },
  components: { 
    SlabItemSelector
  },
  methods: {
    close() {
      this.$emit('input', false);
      // if (clear) {
      //   this.clearData();
      // }
    },
    // clearData() {
    //   Object.assign(this.$data, this.$options.data.call(this));
    // },
    parentDeselect(id) {
      this.$refs['item-selector'].deselect(id);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
@import '@/styles/modal.scss';

.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>
